import {config} from '../../utils.js';
const EVENT_FIRST_TIME_LISTER = 'event-first-time-lister';
const firstTimeListerEventTrigger = () => {
  if (config.triggerFTLEvent) {
    const event = new CustomEvent(EVENT_FIRST_TIME_LISTER);
    document.dispatchEvent(event);
  }
};

export {EVENT_FIRST_TIME_LISTER, firstTimeListerEventTrigger};